export default class InvalidCredentialsError extends Error {
  constructor() {
    super('Usuário/Senha inválido.');
    this.name = 'InvalidCredentialsError';
  }
}
